<template>
  <v-data-table
    :headers="pointDataTableHeaders"
    :items="pointList"
    class="elevation-1"
    :loading="isLoadingPoint"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('point_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('point_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditPointDialog" max-width="800px" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2 ml-8"
              v-bind="attrs"
              v-on="on"
              :disabled="isAllTextFieldDisable"
            >
              {{ $t('point_new_btn') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ dialogTitleHeader }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <ValidationObserver ref="point">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('point_type')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="editedPointIndex === -1"
                      >
                        <v-autocomplete
                          v-model="editedPoint.Type"
                          :items="pointTypeList"
                          item-text="Name"
                          item-value="Type"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          @keyup.enter="setTypeAutocomplete"
                          ref="typeAutocomplete"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('point_type') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                      <ValidationProvider
                        :name="$t('point_type')"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-text-field
                          v-model="turnFormTypeName"
                          :label="$t('point_type')"
                          :error-messages="errors[0]"
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('point_type') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <item-filter-all-type-autocomplete
                        :fatherEditedItem="OneItem"
                        :editedItemIndex="editedPointIndex"
                        :itemName="'item_number'"
                        @setEditedItem="setEditedItem"
                        v-if="editedPointIndex === -1 && isShowEditPointDialog"
                        refName="itemAutocomplete"
                        @keyupEnter="focusNextInput"
                      />
                      <ValidationProvider
                        :name="$t('item_number')"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-text-field
                          v-model="editedPoint.ItemNumber"
                          disabled
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('item_number') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('item_name')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="editedPointIndex === -1"
                      >
                        <v-text-field v-model="OneItem.Name" disabled :error-messages="errors[0]">
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('item_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                      <ValidationProvider
                        :name="$t('item_name')"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-text-field
                          v-model="editedPoint.ItemName"
                          :error-messages="errors[0]"
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('item_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('point_price')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedPoint.Price"
                          @keyup.enter="focusNextInput"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('point_price') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('installation_notice_point')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedPoint.PointQuantity"
                          @keyup.enter="focusNextInput"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_notice_point') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedPoint"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedPoint"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isAllTextFieldDisable"
          :isLoadingSaveBtn="isLoadingDeleteBtn"
          :isShowDeleteDialog="isShowDeletePointDialog"
          :deleteMessage="'point_delete_dialog_message'"
          @closeDelete="closeDeletePoint"
          @confirmDelete="confirmDeletePoint"
        />
      </v-toolbar>
    </template>
    <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template> -->
    <template v-slot:[`item.Type`]="{ item }">
      {{ turnFormType(item.Type) }}
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="isShowEditPointBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="isShowDeletePointBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { HttpPoint } from '@/js/http-Manager'
import { PointType } from '@/js/PointType'
import ItemFilterAllTypeAutocomplete from '@/components/ItemFilterAllTypeAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import axios from 'axios'

export default {
  name: 'Point',
  components: { ItemFilterAllTypeAutocomplete, DeleteDialog },
  data: () => ({
    isShowEditPointDialog: false,
    pointList: [],
    editedPointIndex: -1,
    search: '',
    editedPoint: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      Price: 0,
      PointQuantity: 0,
      Type: null
    },
    defaultPoint: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      Price: 0,
      PointQuantity: 0,
      Type: null
    },
    isLoadingPoint: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    pointSomeSource: null,
    OneItem: {
      Number: '',
      Name: ''
    },
    defaultItem: {
      Number: '',
      Name: ''
    },
    isShowDeletePointDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    pointTypeList: [],
    getIntersectingItemObj: null
  }),
  async mounted () {
    this.getPoint()
    this.getPointType()
  },
  computed: {
    pointDataTableHeaders () {
      return [
        {
          text: this.$t('point_type'),
          align: 'start',
          value: 'Type'
        },
        { text: this.$t('item_number'), align: 'start', value: 'ItemNumber' },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('installation_notice_point'),
          align: 'end',
          value: 'PointQuantity'
        },
        {
          text: this.$t('point_price'),
          align: 'end',
          value: 'Price'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnFormTypeName () {
      return PointType.getPointTypeName(this.editedPoint.Type)
    },
    dialogTitleHeader () {
      return this.editedPointIndex === -1
        ? this.$t('point_new_card_title')
        : this.$t('point_edited_card_title')
    }
  },
  methods: {
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setEditedItem (val) {
      this.OneItem = JSON.parse(JSON.stringify(val))
    },
    async getPointType () {
      let response = await HttpPoint.GetPointTypes()

      this.pointTypeList = response.status === 200 ? response.data.Data : []
    },
    turnFormType (val) {
      return PointType.getPointTypeName(val)
    },
    async getPoint () {
      this.isLoadingPoint = true
      if (this.pointSomeSource) {
        this.pointSomeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.pointSomeSource = cancelToken.source()
      let response = await HttpPoint.GetPoint(this.pointSomeSource.token)
      this.isLoadingPoint = false
      if (response) {
        this.pointList = response.status === 200 ? response.data.Data : []
        this.pointSomeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditPointBtn (item) {
      this.editedPointIndex = this.pointList.indexOf(item)
      this.editedPoint = JSON.parse(JSON.stringify(item))
      this.isShowEditPointDialog = true
    },
    closeEditedPoint () {
      this.isShowEditPointDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.OneItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedPoint = JSON.parse(JSON.stringify(this.defaultPoint))
        this.editedPointIndex = -1
      })
    },

    async saveEditedPoint () {
      const isValid = await this.$refs.point.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingPoint = true
        if (this.OneItem.Number !== '') {
          this.editedPoint.ItemNumber = this.OneItem.Number
          this.editedPoint.ItemName = this.OneItem.Name
          this.editedPoint.ItemId = this.OneItem.Id
        }
        if (this.editedPointIndex !== -1) {
          await HttpPoint.UpdatePoint(this.editedPoint)
        } else {
          await HttpPoint.AddPoint(this.editedPoint)
        }
        await this.getPoint()
        this.closeEditedPoint()
      }
    },
    isShowDeletePointBtn (item) {
      this.editedPointIndex = this.pointList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedPoint = JSON.parse(str)
      this.isShowDeletePointDialog = true
    },
    async confirmDeletePoint () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingPoint = true
      await HttpPoint.DeletePoint(this.pointList[this.editedPointIndex].Id)
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingPoint = false
      await this.getPoint()
      this.closeDeletePoint()
    },

    closeDeletePoint () {
      this.isShowDeletePointDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultPoint)
        this.editedPoint = JSON.parse(str)
        this.editedPointIndex = -1
      })
    }
  }
}
</script>
